import Theme from '@adsk/alloy-react-theme';

export const addCompanyStyle = {
  padding: '5px 0 10px 10px',
};

export const noCompanyTextStyle = {
  color: Theme.colors.charcoal500,
};
